export const consentNeedsUpdate = (consents, term) =>
    consents[term] && (!consents[term].version || consents[term].latestVersion > consents[term].version);
